<template>
  <div class="reset-password">
    <div class="container">
      <div class="brand-content">
        <img src="https://static.bienparabien.com/img/Logo_BPB_alt.png" alt="Logo BpB" width="200px">
        <h1>Restablecer contraseña</h1>
        <p>Personaliza tu contraseña para poder entrar a tú portal.</p>
      </div>
      <div>
        <form @submit.prevent="cambiar_contrasenias">
          <div class="form-group">
            <label for="inputNewPassword" class="col-form-label"><small>Contraseña nueva</small></label>
            <input v-model="credenciales.password" type="password" class="form-control" id="inputNewPassword">
          </div>
          <div class="form-group">
            <label for="inputConfirmNewPassword" class="col-form-label"><small>Confirmar contraseña</small></label>
            <input v-model="credenciales.password_confirmation" type="password" class="form-control" id="inputConfirmNewPassword">
          </div>
          <br />
          <div class="form-group">
            <button class="btn btn-bpb-primary btn-block">Aceptar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import api from '@/api/account';

  export default {
    data: function() {
      return {
        credenciales: {
          password: null
          ,password_confirmation: null
          ,hash: null
        }
      }
    }
    ,methods: {
      cambiar_contrasenias: async function() {
        if (this.credenciales.password != this.credenciales.password_confirmation)
          return this.$swal('Error','La contraseña y la confirmación no son iguales','error');

        if (this.credenciales.password.length < 5)
          return this.$swal('Error','La contraseña debe ser mayor o igual a 5 caracteres');

        // if (!/^(?=.*[A-Z])(?=.*[!@#$_&*])(?=.*[0-9])(?=.*[a-z]).{4,}$/.test(this.credenciales.password))
        //   return this.$swal('Error','La contraseña debe tener al menos un una minuscula, una mayuscula, un número y un caracter especial de esta lista: !@#$_&*','error');

        try {
          this.credenciales.hash = this.$route.params.hash;
          await api.recuperar_password_confirm(this.credenciales);

          const parent = this;
          this.$swal.queue([
            {
              title: 'Exito!'
              ,text: 'Tu contraseña se a actualizado, ahora podrás acceder con la nueva contraseña'
              ,preConfirm: () => {
                parent.$router.push({name: 'Home'});
              }
            }
          ]);

        }catch(e) {
          this.$log.info('err', e);
          this.$swal('Error','Error al intentar cambiar la contraseña: '+e.message,'error');
        }
      }
    }
  }
</script>